import React from 'react';
import "./footer.css";

function Footer() {
  const keywords = [
    "interior designers in chennai",
    "interior design chennai",
    "interior designer near me",
    "interior company in chennai",
    "interior designers chennai",
    "interior designers near me",
    "interior designers in thiruvanmiyur",
    "interior designers in avadi",
    "interior designers in nungambakkam",
    "interior designers in mogappair",
    "interior designers in adyar",
    "interior designers in madipakkam",
    "interior designers in nanganallur",
    "interior designers in tambaram",
    "interior designers in thoraipakkam",
    "interior designers in t nagar",
    "interior designers in villivakkam",
    "interior designers in porur",
    "interior designers in anna nagar",
    "interior designers in kodambakkam",
    "interior designers in medavakkam",
    "FirstSkyInfra Chennai"
  ];

  return (
    <footer className="footer" style={{ background: "#495d4b" }}>
      <div className="container">
        <p className="footer-text">
          © 2025{" "}
          <a
            href="https://firstskyinfra.in"
            target="_blank"
            rel="noopener noreferrer"
            className="brand"
          >
            FirstSkyInfra.com
          </a>{" "}
          All Rights Reserved.
        </p>

        <p className="footer-meta">
          {keywords.map((word, index) => (
            <span key={index} className="keyword">
              {word}
              {index !== keywords.length - 1 && " | "}
            </span>
          ))}
        </p>
      </div>
    </footer>
  );
}

export default Footer;
